import { toast } from "react-toastify";

export const toastErrorMessagePopUp = (message) => {
  // function to display toast popup error message
  toast.error(message, {
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

export const toastSuccessMessagePopUp = (message) => {
  // function to display toast popup success message
  toast.success(message, {
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

export const toastVersionUpdateMessagePopUp = (message) => {
  // function to display toast popup success message
  toast(message, {
      position: "bottom-left",
      autoClose: false,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      toastId: 'version-update'
  });
};